import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('light');
  const [primaryColor, setPrimaryColor] = useState('blue');

  useEffect(() => {
    const savedTheme = localStorage.getItem('gallery-theme');
    const savedColor = localStorage.getItem('gallery-primary-color');
    
    if (savedTheme) {
      setTheme(savedTheme);
    }
    if (savedColor) {
      setPrimaryColor(savedColor);
    }
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('gallery-theme', newTheme);
  };

  const changePrimaryColor = (color) => {
    setPrimaryColor(color);
    localStorage.setItem('gallery-primary-color', color);
  };

  const value = {
    theme,
    primaryColor,
    toggleTheme,
    changePrimaryColor,
    isDark: theme === 'dark'
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};